export default __webpack_public_path__ + "static/media/6.83afb627.png";